import { render, staticRenderFns } from "./WebNotes.vue?vue&type=template&id=4fc3ceba"
import script from "./WebNotes.vue?vue&type=script&lang=js"
export * from "./WebNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports